import {
  Button,
  ButtonGroup,
  Grid,
  Heading,
  Input,
  Label,
  SelectField,
  Text,
  View,
} from "@aws-amplify/ui-react"
import type {
  MachineSupaDto,
  OrganizationDto,
  UserOrgsRolesDto,
} from "@strtmn/sds/types"
import { getErrorMessage } from "@strtmn/strtmn"
import { I18n } from "aws-amplify/utils"
import { useState } from "react"
import {
  Controller,
  FormProvider,
  useForm,
  type SubmitHandler,
} from "react-hook-form"
import { useNavigate } from "react-router-dom"
import {
  addMachineToOrg,
  createMachine,
  // updateMachine,
} from "../../api/MachinesApi"
import { isDev, isProd } from "../../config"
import { CancelButton, CopyToClipboard } from ".."

interface AddToOrgFormProps {
  allOrgs: OrganizationDto[]
  machineData: MachineSupaDto
  setShowAddToOrgForm: React.Dispatch<React.SetStateAction<boolean>>
}
const AddToOrgForm = ({
  allOrgs,
  machineData,
  setShowAddToOrgForm,
}: AddToOrgFormProps) => {
  const navigate = useNavigate()
  const methods = useForm<{ orgId: string; orgRole: UserOrgsRolesDto }>({
    defaultValues: { orgId: "", orgRole: "CUSTOMER" },
  })
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setError,
  } = methods

  const onAddToOrg = async (data: {
    orgId: string
    orgRole: UserOrgsRolesDto
  }) => {
    console.log("▶️ onAddToOrg")
    console.log("🪅🪅🪅 data:", data)
    const selectedOrg = allOrgs.find((o) => o.id === data.orgId)
    if (!selectedOrg) {
      console.warn(`Could not find org ${data.orgId}`)
      setError("root.clientError", {
        message: `${I18n.get("Fehler")}: ${I18n.get("Betrieb nicht gefunden.")}`,
      })
      return
    }

    // Prevent duplicates
    if (
      machineData.MachinesOrganizations?.find(
        (mo) => mo.org_id === selectedOrg.id
      )
    ) {
      console.log(`Machine is already member of org ${data.orgId}`)
      setError("root.clientError", {
        message: `${I18n.get("Fehler")}: ${I18n.get("Die Maschine ist bereits Teil des Betriebs.")}`,
      })
      return
    }

    // const updated = {
    //   ...userData,
    //   Organizations: [...userData.Organizations, selectedOrg],
    // }

    // setMyObject(updated)

    // Optionally call your backend here
    console.log("Send to backend:", {
      machine_id: machineData.id,
      org_id: data.orgId,
    })
    try {
      await addMachineToOrg(machineData.id, data.orgId)
      reset()
      setShowAddToOrgForm(false)
      navigate(0)
    } catch (error) {
      const eAsAny = error as any
      setError("root.serverError", {
        type: eAsAny.statusCode,
        message: isProd
          ? "Fehler beim Speichern."
          : "Fehler beim Speichern: " + getErrorMessage(eAsAny.body),
      })
    }
  }

  for (const org of allOrgs) {
    console.log("org:", org)
  }
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onAddToOrg)}>
        <Text color="white">{I18n.get("Zu einem Betrieb hinzufügen")}</Text>

        {errors?.root && errors?.root["clientError"] && (
          <p className="error">{errors.root["clientError"].message}</p>
        )}
        {errors?.root && errors?.root["serverError"] && (
          <p className="error">{errors.root["serverError"].message}</p>
        )}

        <Controller
          name="orgId"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <SelectField label="" labelHidden={true} {...field}>
              <option value={0}>
                {I18n.get("Wählen Sie einen Betrieb aus")}
              </option>
              {allOrgs.map((o) => (
                <option key={o.id} value={o.id}>
                  {o.name} |{" "}
                  {o.address
                    ? typeof o.address === "string"
                      ? o.address
                      : o.address.city + ", " + o.address.street
                    : I18n.get("ohne Adresse")}{" "}
                  {/* | {o.type} */}
                  {isDev && ` | ${o.id}`}
                </option>
              ))}
            </SelectField>
          )}
        />
        {/* <Text color="white">
          {I18n.get(
            "Benutzer, die einem Betrieb zugeordnet sind, haben dann Zugriff auf die Maschinen in diesem Betrieb."
          )}
        </Text> */}
        <ButtonGroup className="buttons !mt-4" size="small">
          <Button variation="primary" type="submit">
            {I18n.get("Speichern")}
          </Button>
          <Button
            backgroundColor="white"
            onClick={() => {
              reset()
              setShowAddToOrgForm(false)
            }}
          >
            {I18n.get("Abbrechen")}
          </Button>
        </ButtonGroup>
      </form>
    </FormProvider>
  )
}

interface MachineMaskProps {
  machine: MachineSupaDto
  isNewMachine: boolean
  allOrgs: OrganizationDto[]
}

export default function MachineMask({
  machine,
  isNewMachine,
  allOrgs,
}: MachineMaskProps) {
  console.log("> MachineMask")
  console.log("machine:", machine)
  console.log("isNewMachine:", isNewMachine)
  // console.log("allOrgs:", allOrgs)
  const navigate = useNavigate()
  const [isFormSubmitting /*, setIsFormSubmitting*/] = useState(false)
  const [showAddToOrgForm, setShowAddToOrgForm] = useState(false)

  if (isNewMachine) {
    machine.id = ""
    machine.name = ""
    machine.serial_number = ""
    machine.modem_serial = ""
    machine.created_at = ""
    machine.created_by = ""
    machine.updated_at = ""
    machine.updated_by = ""
  }

  const methods = useForm<MachineSupaDto>({
    values: machine,
  })
  const {
    register,
    handleSubmit,
    setError,
    // setValue,
    formState: { errors },
    // watch,
  } = methods

  const onSubmit: SubmitHandler<MachineSupaDto> = async (data) => {
    console.log("▶️ onSubmit")
    console.log("data:", data)
    try {
      if (isNewMachine) {
        await createMachine(data)
      } else {
        !isProd && console.log(data)
        setError("root.serverError", {
          message: `Hinweis: Maschinen bearbeiten wird noch nicht unterstützt.`,
        })
        return
        /** @note data looks okay. Is the backend endpoint there? */
        // await updateMachine(data.id, data)
      }
      navigate(0)
    } catch (err) {
      setError("root.serverError", {
        message: `${I18n.get("Fehler")}: ${I18n.get("Konnte die Maschine nicht speichern.")}`,
      })
    }
  }

  return (
    <Grid rowGap="0.5rem" columnGap="0.5rem">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {errors?.root && errors?.root["clientError"] && (
            <p className="error">{errors.root["clientError"].message}</p>
          )}
          {errors?.root && errors?.root["serverError"] && (
            <p className="error">{errors.root["serverError"].message}</p>
          )}

          <Heading className="!border-solid !border-0 !border-b-4 !pb-2 !mb-2">
            {I18n.get("Stammdaten")}
          </Heading>

          <Label>{I18n.get("VIN")}</Label>
          <Input {...register("serial_number")} placeholder={I18n.get("VIN")} />
          <Label>{I18n.get("Name")}</Label>
          <Input {...register("name")} placeholder={I18n.get("Name")} />
          <Label>{I18n.get("Maschinen-Typ")}</Label>
          <Input
            {...register("machine_type")}
            placeholder={I18n.get("Maschinen-Typ")}
          />

          {!isProd && (
            <small>
              <div>{/* divider */}&nbsp;</div>
              <div>
                <Label>{I18n.get("Machine ID")}:</Label> {machine.id}{" "}
                <CopyToClipboard text={machine.id} />
              </div>
              <div>
                <Label>{I18n.get("Modem S/N")}:</Label> {machine.modem_serial}{" "}
                <CopyToClipboard text={machine.modem_serial} />
              </div>
              <div>
                <Label>{I18n.get("Machine Attributes")}:</Label>{" "}
                {JSON.stringify(machine.machine_attributes)}
              </div>
            </small>
          )}

          <div>{/* divider */}&nbsp;</div>
          <ButtonGroup className="buttons !mt-4" size="small">
            <Button
              type="submit"
              variation="primary"
              isDisabled={isFormSubmitting}
              isLoading={isFormSubmitting}
              loadingText={I18n.get("Wird gespeichert...")}
            >
              {I18n.get("Speichern")}
            </Button>
            <CancelButton
              href=".."
              title="Abbrechen"
              isDisabled={isFormSubmitting}
            />
          </ButtonGroup>
        </form>
      </FormProvider>

      {!isNewMachine && (
        <>
          <div>{/* divider */}&nbsp;</div>

          <Heading className="!border-solid !border-0 !border-b-4 !pb-2">
            {I18n.get("Betriebe")}
          </Heading>
          {!machine.MachinesOrganizations ||
          !Array.isArray(machine.MachinesOrganizations) ||
          machine.MachinesOrganizations.length === 0 ? (
            <div>
              {I18n.get("Diese Maschine ist keinem Betrieb zugewiesen.")}
            </div>
          ) : (
            <table className="machine-orgs">
              <thead>
                <tr>
                  <th>{I18n.get("Betrieb")}</th>
                  {/* <th>{I18n.get("Betriebstyp")}</th> */}
                  {!isProd && <th>Betriebs-ID</th>}
                </tr>
              </thead>
              <tbody>
                {machine.MachinesOrganizations.map((mo) => {
                  const orgId = mo.org_id
                  const org = allOrgs.find((o) => o.id === orgId)
                  const orgName = org
                    ? org.name
                    : "Betrieb nicht gefunden: " + orgId
                  return { orgId, name: orgName }
                })
                  .sort((a, b) =>
                    a.name.localeCompare(b.name, undefined, {
                      sensitivity: "base",
                      numeric: true,
                    })
                  )
                  .map((mo) => {
                    return (
                      <tr key={mo.orgId}>
                        <td>{mo.name}</td>
                        {/* <td>{I18n.get(org.type ?? "unknown")}</td> */}
                        {!isProd && (
                          <td>
                            {mo.orgId} <CopyToClipboard text={mo.orgId} />
                          </td>
                        )}
                      </tr>
                    )
                  })}
              </tbody>
            </table>
          )}

          {showAddToOrgForm ? (
            <View className="bg-slate-400 p-4">
              <AddToOrgForm
                allOrgs={allOrgs}
                machineData={machine}
                setShowAddToOrgForm={setShowAddToOrgForm}
              />
            </View>
          ) : (
            <View>
              <Button size="small" onClick={() => setShowAddToOrgForm(true)}>
                {I18n.get("Zu einem Betrieb hinzufügen")}
              </Button>
            </View>
          )}

          {/* <table style={{ width: "50%" }}>
              <thead>
                <tr>
                  <th>{I18n.get("Rollen")}</th>
                </tr>
              </thead>
              <tbody>
                {user.roles.map((role) => (
                  <tr key={role.id}>
                    <td>{role.name}</td>
                  </tr>
                ))}
              </tbody>
            </table> */}
        </>
      )}
    </Grid>
  )
}
